
import { useState } from "react";
import { ShoppingBag, Check } from "lucide-react";
import { useCart, type CartItem } from "@/lib/cart";
import { brandColors as colors } from "@/lib/palette";
import { fonts } from "@/lib/fonts";

type Props = {
  product: Omit<CartItem, "quantity">;
  outOfStock?: boolean;
  compact?: boolean;
};

export default function AddToCartButton({
  product,
  outOfStock,
  compact,
}: Props) {
  const { addItem } = useCart();
  const [added, setAdded] = useState(false);

  function handleClick() {
    addItem(product);
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  }

  if (outOfStock) {
    return (
      <button
        type="button"
        disabled
        className={`inline-flex items-center justify-center gap-2 rounded-full text-white opacity-60 cursor-not-allowed ${compact ? "px-4 py-2 text-xs" : "px-6 py-3 text-sm"}`}
        style={{
          fontFamily: fonts.button,
          fontWeight: 700,
          letterSpacing: "0.05em",
          textTransform: "uppercase",
          backgroundColor: colors.navy,
        }}
      >
        Out of Stock
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center justify-center gap-2 rounded-full text-white cursor-pointer transition-all duration-200 hover:shadow-lg hover:scale-105 ${compact ? "px-4 py-2 text-xs" : "px-6 py-3 text-sm"}`}
      style={{
        fontFamily: fonts.button,
        fontWeight: 700,
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        backgroundColor: added ? colors.forestGreen : colors.berryPink,
      }}
    >
      {added ? (
        <>
          <Check size={compact ? 14 : 16} />
          Added
        </>
      ) : (
        <>
          <ShoppingBag size={compact ? 14 : 16} />
          {compact ? "Add" : "Add to Cart"}
        </>
      )}
    </button>
  );
}
